import React from "react";
import {css, getFont, Help, getBaseColor} from "@core-ui/react-stitch";
import {RadioStyleFn, CommonProps, GetStyles, RadioProps} from "../types";

type LabelTextProps = CommonProps &
  Pick<RadioProps, "helpText" | "label"> & {
    getClassName: (elementName: string) => string;
    getStyles: GetStyles;
  };

const getColor: RadioStyleFn = (props) => {
  const baseColor = "gray60";
  return getBaseColor(baseColor)(props);
};

const getFontSize: RadioStyleFn<string> = ({
  theme,
  crossBrand,
  isRadioSmall,
}) => {
  if (isRadioSmall) return "0.875rem";
  if (crossBrand) return "1.1rem";
  if (["gap", "gapfs", "at"].includes(theme.brand)) return "1.063rem";
  return "1rem";
};

const getLabelCSS: RadioStyleFn = (props) => ({
  display: "inline-block",
  verticalAlign: "middle",
  lineHeight: 1.5,
  color: getColor(props),

  // makes sure that the label does not break width
  maxWidth: "calc(100% - 2.3025rem)",
  fontSize: getFontSize(props),
  ...getFont("primary")(props),
});

const LabelText = ({
  crossBrand,
  disabled,
  helpText,
  label,
  getClassName,
  getStyles,
  isRadioSmall,
}: LabelTextProps): JSX.Element => {
  const styleProps = {crossBrand, disabled, isRadioSmall};
  return (
    <span
      className={getClassName("label-text")}
      css={(theme) => ({
        ...getLabelCSS({theme, ...styleProps}),
        ...getStyles("labelText"),
      })}
    >
      {label}
      {helpText && (
        <Help
          {...styleProps}
          className={getClassName("help")}
          css={getStyles("helpText")}
        >
          {helpText}
        </Help>
      )}
    </span>
  );
};

export default LabelText;
